import React from "react";
import styles from "./BetTableRace20.module.css";

const BetTableRace20 = ({ data, runnersData = [], exposures = {} }) => {
  const getExposure = (runnerName) => {
    const exposureKeys = [
      runnerName,
      runnerName?.toLowerCase(),
      runnerName?.trim()
    ];
    
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined) {
        return exposures[key];
      }
    }
    return 0;
  };

  // Map suit to card image path
  const getCardImage = (suit) => {
    const suitMap = {
      "♠": "/assets/img/race20/KSS.jpg",
      "♥": "/assets/img/race20/KHH.jpg",
      "♣": "/assets/img/race20/KCC.jpg",
      "♦": "/assets/img/race20/KDD.jpg"
    };
    return suitMap[suit] || "/assets/img/race20/KSS.jpg";
  };

  // Get card suit from label
  const getSuitFromLabel = (label) => {
    if (label?.toLowerCase().includes("spade")) return "♠";
    if (label?.toLowerCase().includes("heart")) return "♥";
    if (label?.toLowerCase().includes("club")) return "♣";
    if (label?.toLowerCase().includes("diamond")) return "♦";
    return "♠";
  };

  const isLocked = (value, betData) => {
    return value === 0 || value === undefined || betData?.gstatus?.toUpperCase() === "SUSPENDED";
  };

  return (
    <div className={styles.container}>
      {/* Top section: 4 card sections */}
      <div className={styles.cardContent}>
        <div className={styles.casinoOddsBoxWrapper}>
          {[0, 1, 2, 3].map((index) => {
            const betData = runnersData[index] || {};
            const label = betData?.nat || (index === 0 ? "K of spade" : index === 1 ? "K of heart" : index === 2 ? "K of club" : "K of diamond");
            const suit = getSuitFromLabel(label);
            const b = data[`k${suit === "♠" ? "s" : suit === "♥" ? "h" : suit === "♣" ? "c" : "d"}b`] || betData?.b || 0;
            const l = data[`k${suit === "♠" ? "s" : suit === "♥" ? "h" : suit === "♣" ? "c" : "d"}l`] || betData?.l || 0;
            const isBackLocked = isLocked(b, betData);
            const isLayLocked = isLocked(l, betData);
            const exposure = getExposure(label) || getExposure(betData?.nat);
            const displayExposure = exposure !== 0 ? (exposure < 0 ? exposure.toFixed(0) : `+${exposure.toFixed(0)}`) : "0";

            return (
              <div key={index} className={`${styles.casinoOddsBoxContainer} ${styles.casinoOddsBoxContainerDouble}`}>
                <div className={styles.casinoOddsBoxBhav}>
                  <img src={getCardImage(suit)} alt={label} onError={(e) => e.target.style.display = 'none'} />
                </div>
                <div className={styles.casinoOddsBox}>
                  <div 
                    className={`${styles.backBorder} ${isBackLocked ? styles.suspendedBox : ""}`}
                    style={{ position: 'relative' }}
                  >
                    <span className={styles.casinoOddsBoxOdd}>{b || 0}</span>
                  </div>
                  <div 
                    className={`${styles.layBorder} ${isLayLocked ? styles.suspendedBox : ""}`}
                    style={{ position: 'relative' }}
                  >
                    <span className={styles.casinoOddsBoxOdd}>{l || 0}</span>
                  </div>
                </div>
                <div className={styles.casinoOddsBook} style={{ color: exposure !== 0 ? (exposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                  {displayExposure}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Middle section: Total points and Total cards */}
      <div className={styles.mt2}>
        <div className={styles.cardContent}>
          {/* Total points */}
          <TotalRow
            title="Total points"
            noValue={data.tpb}
            noSub={data.tpbm}
            yesValue={data.tpl}
            yesSub={data.tplm}
            noLabel="Total Points"
            yesLabel="Total Points"
            betData={runnersData[4]}
            exposures={exposures}
          />

          {/* Total cards */}
          <TotalRow
            title="Total cards"
            noValue={data.tcb}
            noSub={data.tcbm}
            yesValue={data.tcl}
            yesSub={data.tcls}
            noLabel="Total Cards"
            yesLabel="Total Cards"
            betData={runnersData[5]}
            exposures={exposures}
          />
        </div>
      </div>

      {/* Bottom section: Win with X */}
      <div className={styles.mt2}>
        <div className={styles.cardContent}>
          <div className={`${styles.row} ${styles.row5}`}>
            {["5", "6", "7", "15", "16", "17"].map((num, idx) => {
              const mappedIndex = 6 + idx;
              const betData = runnersData[mappedIndex] || {};
              const value = data[`w${num}`] || betData?.b || 0;
              const isLockedValue = isLocked(value, betData);
              const label = `Win with ${num}`;
              const exposure = getExposure(label) || getExposure(betData?.nat);
              const displayExposure = exposure !== 0 ? (exposure < 0 ? exposure.toFixed(0) : `+${exposure.toFixed(0)}`) : "0";

              return (
                <div key={num} className={styles.col4}>
                  <div className={`${styles.casinoOddsBoxContainer} ${styles.casinoOddsBoxContainerExtra}`}>
                    <div className={styles.casinoOddsBoxBhav}>
                      <div style={{ fontSize: '14px'}}>{label}</div>
                    </div>
                    <div 
                      className={`${styles.casinoOddsBox} ${styles.backBorder} ${isLockedValue ? styles.suspendedBox : ""}`}
                      style={{ position: 'relative' }}
                    >
                      <span className={styles.casinoOddsBoxOdd}>{value || 0}</span>
                    </div>
                    <div className={styles.casinoOddsBook} style={{ color: exposure !== 0 ? (exposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
                      {displayExposure}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

const TotalRow = ({ title, noValue, noSub, yesValue, yesSub, noLabel, yesLabel, betData, exposures = {} }) => {
  const isNoLocked = noValue === 0 || noValue === undefined || betData?.gstatus?.toUpperCase() === "SUSPENDED";
  const isYesLocked = yesValue === 0 || yesValue === undefined || betData?.gstatus?.toUpperCase() === "SUSPENDED";

  const runnerName = betData?.nat || title;

  const getExposure = (playerName) => {
    const exposureKeys = [
      playerName,
      playerName?.toLowerCase(),
      runnerName,
      runnerName?.toLowerCase(),
      title,
      title?.toLowerCase(),
      noLabel,
      noLabel?.toLowerCase(),
      yesLabel,
      yesLabel?.toLowerCase()
    ];
    
    for (const key of exposureKeys) {
      if (key && exposures[key] !== undefined) {
        return exposures[key];
      }
    }
    return 0;
  };

  const exposure = getExposure(runnerName || title);
  const displayExposure = exposure !== 0 ? (exposure < 0 ? exposure.toFixed(0) : `+${exposure.toFixed(0)}`) : "0";

  return (
    <div className={`${styles.casinoOddsBoxContainer} ${styles.casinoOddsBoxContainerExtra}`}>
      {/* Header row with No/Yes labels */}
      <div className={styles.casinoYn}>
        <div></div>
        <div className={styles.casinoOddsBoxBhav}><div style={{ display: 'flex', alignItems: 'center', fontSize: '14px'}}>No</div></div>
        <div className={styles.casinoOddsBoxBhav}><div style={{ display: 'flex', alignItems: 'center', fontSize: '14px'}}>Yes</div></div>
      </div>
      {/* Content row with title and betting boxes */}
      <div className={`${styles.casinoOddsBox} ${styles.casinoYn}`}>
        <div className={styles.casinoOddsBoxBhav}>
          <b>{title}</b>
        </div>
        <div 
          className={`${styles.layBorder} ${isNoLocked ? styles.suspendedBox : ""}`}
          style={{ position: 'relative' }}
        >
          <span className={styles.casinoOddsBoxOdd}>{noValue || 0}</span>
          <span>{noSub || 0}</span>
        </div>
        <div 
          className={`${styles.backBorder} ${isYesLocked ? styles.suspendedBox : ""}`}
          style={{ position: 'relative' }}
        >
          <span className={styles.casinoOddsBoxOdd}>{yesValue || 0}</span>
          <span>{yesSub || 0}</span>
        </div>
      </div>
      <div className={styles.casinoOddsBook} style={{ color: exposure !== 0 ? (exposure < 0 ? '#ff0000' : '#00ff00') : 'black' }}>
        {displayExposure}
      </div>
    </div>
  );
};

export default BetTableRace20;

